import { RESET_WIZARD, SAVE_AND_TEST_CAMPAIGN_ASYNC } from '../constants'

import {
  CHANGE_TEST_CAMPAIGN_DATA,
  FETCH_TEST_CAMPAIGN_EMAILS_ASYNC,
  SET_ERROR,
  SET_TEST_CAMPAIGN_EMAILS_PAGE,
  SET_USER_MAILBOX_ID,
} from './constants'

export const DEFAULT_TEST_CAMPAIGN_DATA = {
  profileIds: [],
  selectedScenarios: [],
  trainingReminderIndices: [],
  sendSimulationFailedEmail: true,
  sendTrainingCompletionEmail: true,
  sendNotifyManagerEmail: true,
  includeTrainingReminders: true,
}

export default function () {
  const initialState = {
    loader: false,
    error: null,
    testCampaignEmailsData: {
      page: 1,
      loader: true,
      error: null,
      items: [],
    },
    testCampaignData: DEFAULT_TEST_CAMPAIGN_DATA,
    testCampaignLoader: false,
    userMailboxId: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case SET_ERROR:
        return {
          ...state,
          error: action.payload.value,
        }
      case SET_TEST_CAMPAIGN_EMAILS_PAGE:
        return {
          ...state,
          testCampaignEmailsData: {
            ...state.testCampaignEmailsData,
            page: action.payload.page,
          },
        }
      case FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.INITIATE:
        return {
          ...state,
          testCampaignEmailsData: {
            ...state.testCampaignEmailsData,
            loader: true,
            error: null,
          },
        }
      case FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.SUCCESS:
        return {
          ...state,
          testCampaignEmailsData: {
            ...state.testCampaignEmailsData,
            items:
              state.testCampaignEmailsData.page === 1
                ? action.payload.items
                : [...state.testCampaignEmailsData.items, ...action.payload.items],
            loader: false,
          },
        }
      case FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.ERROR:
        return {
          ...state,
          testCampaignEmailsData: {
            ...state.testCampaignEmailsData,
            error: action.error,
            loader: false,
          },
        }
      case FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.CANCEL:
        return {
          ...state,
          testCampaignEmailsData: {
            ...state.testCampaignEmailsData,
            loader: false,
          },
        }
      case CHANGE_TEST_CAMPAIGN_DATA: {
        return {
          ...state,
          testCampaignData: {
            ...state.testCampaignData,
            ...action.payload.data,
          },
        }
      }
      case SAVE_AND_TEST_CAMPAIGN_ASYNC.INITIATE:
        return {
          ...state,
          testCampaignLoader: true,
        }
      case SAVE_AND_TEST_CAMPAIGN_ASYNC.SUCCESS:
      case SAVE_AND_TEST_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          testCampaignLoader: false,
        }
      case SET_USER_MAILBOX_ID:
        return {
          ...state,
          userMailboxId: action.payload.data?.meta?.count ? action.payload.data.items[0].id : null,
        }
      default:
        return state
    }
  }
}
